import { Box } from '@mui/material'
import React from 'react'

import { EthIcon, UserIcon } from '../../Components'

const IconArea: React.FC = () => {
  return (
    <Box display="flex" flexDirection="row">
      <EthIcon />
      <UserIcon />
    </Box>
  )
}

export default IconArea
